"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[973],{

/***/ 44477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WorkableApplicationForm": function() { return /* binding */ WorkableApplicationForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_module_Background__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9403);
/* harmony import */ var _components_module_Width__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55668);
/* harmony import */ var _components_module_Wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83118);






var WorkableApplicationForm = function(param) {
    var shortcode = param.shortcode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Wrapper__WEBPACK_IMPORTED_MODULE_5__/* .Wrapper */ .i, {
        theme: {
            space: {
                top: "none",
                bottom: "lg"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Width__WEBPACK_IMPORTED_MODULE_4__/* .Width */ .L, {
            width: "inner",
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("relative bg-[#F9F9F9] p-8 md:p-10 lg:p-12 xl:p-16", _components_module_Background__WEBPACK_IMPORTED_MODULE_3__/* .roundedOuterModuleClasses.top */ .$T.top, _components_module_Background__WEBPACK_IMPORTED_MODULE_3__/* .roundedOuterModuleClasses.bottom */ .$T.bottom),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                title: "Workable application form",
                src: "https://jobs.eu.lever.co/prima/".concat(shortcode, "/apply/"),
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("w-full h-[2200px] border-0", _components_module_Background__WEBPACK_IMPORTED_MODULE_3__/* .roundedInnerModuleClasses.top */ .Xq.top, _components_module_Background__WEBPACK_IMPORTED_MODULE_3__/* .roundedInnerModuleClasses.bottom */ .Xq.bottom)
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(WorkableApplicationForm));


/***/ })

}]);